import React, { Fragment } from 'react'
import {
  CustomH5,
  CustomTableHeadCell,
  CustomTableHeadLoadingRow,
  CustomTableHeadRow
} from './styles'
import { getWidth } from '../../helpers'

export const TableHeadComponent = ({
  headerGroups,
  isLoading,
  columns,
  isScrollable,
  isHeaderSticky
}) => {
  const columnsTotalWidth = columns.reduce((a, c) => a + c.width, 0)
  return isLoading ? (
    <CustomTableHeadLoadingRow>
      <th colSpan={columns.length} />
    </CustomTableHeadLoadingRow>
  ) : (
    <Fragment>
      {headerGroups.map((headerGroup) => (
        <CustomTableHeadRow sticky={isHeaderSticky} {...headerGroup.getHeaderGroupProps()} data-testid="table-header-row">
          {headerGroup.headers.map((column) => (
            <CustomTableHeadCell
              {...column.getHeaderProps()}
              sticky={isHeaderSticky}
              headerwidth={
                isScrollable ? `${column.width}px` : getWidth(column.width, columnsTotalWidth)
              }
              className={column.headerClassName}
            >
              <CustomH5>
                {column.render('Header')}
                {column.toolTip ? column.toolTip : null}
              </CustomH5>
            </CustomTableHeadCell>
          ))}
        </CustomTableHeadRow>
      ))}
    </Fragment>
  )
}
